<template>
  <div class="h-full p-2.5">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      class="grid h-full gap-x-3 overflow-y-auto px-2.5"
      style="grid-template-columns: 0.8fr 1fr"
    >
      <div class="flex flex-col">
        <el-form-item
          label="会议名称"
          prop="name"
          :rules="[
            { required: true, message: '请输入会议名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <ul class="gap-x-3 grid grid-cols-3">
          <el-form-item
            label="开始日期"
            prop="start_date"
            :rules="[
              { required: true, message: '请选择开始日期', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.start_date"
              type="date"
              placeholder="--请选择--"
            />
          </el-form-item>
          <el-form-item
            label="结束日期"
            prop="end_date"
            :rules="[
              { required: true, message: '请选择结束日期', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.end_date"
              type="date"
              placeholder="--请选择--"
            />
          </el-form-item>
          <el-form-item
            label="咨询电话"
            prop="phone"
            :rules="[
              { required: true, message: '请输入咨询电话', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.phone"></el-input>
          </el-form-item>
        </ul>
        <ul class="items-center gap-x-3 grid grid-cols-2">
          <el-form-item
            label="报名开始时间"
            prop="signup_start_time_date"
            :rules="[
              {
                required: true,
                message: '请选择报名开始时间',
                trigger: 'blur',
              },
              {
                validator: (rule, value, callback) => {
                  if (!state.model.signup_start_time_time)
                    return callback(new Error('请选择报名开始时间'));
                  else callback();
                },
                trigger: 'blur',
              },
              ,
            ]"
          >
            <div class="grid items-center gap-x-2 grid-cols-2">
              <el-date-picker
                v-model="state.model.signup_start_time_date"
                type="date"
                placeholder="报名开始日期"
                value-format="YYYY-MM-DD"
                class="!w-full"
              />
              <el-time-select
                v-model="state.model.signup_start_time_time"
                start="05:00"
                step="00:30"
                end="24:00"
                class="!w-full"
                placeholder="报名开始时间"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="报名截止时间"
            prop="signup_end_time_date"
            :rules="[
              {
                required: true,
                message: '请选择报名截止时间',
                trigger: 'blur',
              },
              {
                validator: (rule, value, callback) => {
                  if (!state.model.signup_end_time_time)
                    return callback(new Error('请选择报名截止时间'));
                  else callback();
                },
                trigger: 'blur',
              },
              ,
            ]"
          >
            <div class="grid items-center gap-x-2 grid-cols-2">
              <el-date-picker
                v-model="state.model.signup_end_time_date"
                type="date"
                placeholder="报名截止日期"
                value-format="YYYY-MM-DD"
                class="!w-full"
              />
              <el-time-select
                v-model="state.model.signup_end_time_time"
                start="05:00"
                step="00:30"
                end="24:00"
                class="!w-full"
                placeholder="报名截止时间"
              />
            </div>
          </el-form-item>
        </ul>
        <el-form-item
          label="大会地址"
          prop="address"
          :rules="[
            { required: true, message: '请选择大会地址', trigger: 'blur' },
          ]"
          class="!mb-0 flex-1 !flex flex-col"
        >
          <div class="h-full w-full flex flex-col !min-h-80">
            <el-input v-model="state.model.address"></el-input>
            <div class="mt-2 flex-1 relative">
              <c_map
                :point="[state.model?.longitude, state.model?.latitude]"
                @setAddress="
                  (item) => {
                    if (!state.model.province) {
                      state.model.province = item.province;
                      state.model.city = item.city;
                      state.model.district = item.district;
                    }
                    state.model.longitude = item.longitude;
                    state.model.latitude = item.latitude;

                    state.model.address = item.address;
                    state.model.area = [
                      item.province,
                      item.city,
                      item.district,
                    ];
                  }
                "
              />
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="grid" style="grid-template-rows: 1fr auto">
        <el-form-item label="会议简介" class="!flex flex-col">
          <!-- <el-input
            v-model="state.model.intro"
            type="textarea"
            class="!h-full"
            input-style="height:100%"
          ></el-input> -->
          <c_editor
            @change="
              (value) => {
                state.model.intro = value;
              }
            "
            class="flex flex-col h-full"
            :value="state.model.intro"
          ></c_editor>
        </el-form-item>
        <el-button type="primary" class="w-full" size="large" @click="onSubmit">
          提交
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_website_meetingInfo,
  meeting_website_meetingInfoSave,
} from "@/http/meeting";
import { dayjs } from "element-plus";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.meeting_id) {
        meeting_website_meetingInfo(props.meeting_id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;

            const signup_start_times = data.signup_start_time.split(" ");
            if (signup_start_times.length == 2) {
              state.model.signup_start_time_date = signup_start_times[0];
              state.model.signup_start_time_time = dayjs(signup_start_times[1], "HH:mm:ss").format("HH:mm");
            }

            const signup_end_times = data.signup_end_time.split(" ");
            if (signup_end_times.length == 2) {
              state.model.signup_end_time_date = signup_end_times[0];
              state.model.signup_end_time_time = dayjs(signup_end_times[1], "HH:mm:ss").format("HH:mm");
            }
          }
        });
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.area?.length == 3) {
            state.model.province = state.model.area[0];
            state.model.city = state.model.area[1];
            state.model.district = state.model.area[2];
          }

          if (state.model.dates?.length == 2) {
            state.model.start_date = state.model.dates[0];
            state.model.end_date = state.model.dates[1];
          }

          state.model.signup_end_time =
            state.model.signup_end_time_date +
            " " +
            state.model.signup_end_time_time;

          state.model.signup_start_time = dayjs(
            state.model.signup_start_time_date +
              " " +
              state.model.signup_start_time_time,
          ).format("YYYY-MM-DD HH:mm:ss");

          state.model.signup_end_time = dayjs(
            state.model.signup_end_time_date +
              " " +
              state.model.signup_end_time_time,
          ).format("YYYY-MM-DD HH:mm:ss");

          meeting_website_meetingInfoSave(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("refresh");
              }, 500);
            });
          });
        }
      });
    };
    return { state, formDom, onSubmit };
  },
};
</script>

<style lang="less" scoped></style>
